import React from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import LinkedSchedule from '../components/syncSchedule/LinkedSchedule';
import { connect } from 'react-redux';

const SyncSchedule = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <LinkedSchedule {...props} />
    </LocalizationProvider>
  );
};

const mapStateToProps = (state, props) => {
  const flowId = state.flows.selectedFlow;
  const flow = state.flows.linkedFlows[flowId];
  const entity = state.entities.selectedEntity;
  return {
    flow,
    entity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncSchedule);
